document.addEventListener('DOMContentLoaded', function() {
  function highlightSelectedTag() {
    const tagList = document.querySelectorAll(".tagline a");
    const url = window.location.href;
  
    tagList.forEach(tag => {
      if(tag.href === url) {
        tag.classList.add("selected")
      }
    });
  }

  highlightSelectedTag();
});

function goBack() {
  window.history.back();
}
